import { render } from "./DetailRecordsList.vue?vue&type=template&id=1d7aa5b5&ts=true"
import script from "./DetailRecordsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailRecordsList.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/Plots/DetailRecordsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d7aa5b5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d7aa5b5', __exports__)) {
    console.log('reload')
    api.reload('1d7aa5b5', __exports__)
  }
  
  module.hot.accept("./DetailRecordsList.vue?vue&type=template&id=1d7aa5b5&ts=true", () => {
    console.log('re-render')
    api.rerender('1d7aa5b5', render)
  })

}


export default __exports__